import React, { useEffect, useState } from "react";
import { Patient } from "../../interfaces/Patient";
import { useParams } from "react-router-dom";
import { getPatient } from "../../apis/patient";
import { getReferredDoctors } from "../../apis/referredDoctor";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  changePatient,
  selectPatient,
} from "../../features/patient/patientSlice";
import { convertFromRaw } from "draft-js";

const Summary: React.FC<{ errors: Patient | null }> = ({ errors }) => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const patient = useAppSelector(selectPatient);
  const [comments, setComments] = useState<any>();
  const [doctors, setDoctors] = useState<Array<{ id: number; name: string }>>(
    []
  );
  const [medicines, setMedicines] = useState<any>();
  const [familyHistory, setFamilyHistory] = useState<any>();

  const fetchDoctors = () => {
    getReferredDoctors()
      .then((res: any) => {
        setDoctors(res.data || []);
      })
      .catch((err) => {
        console.error("Error fetching doctors:", err);
      });
  };

  useEffect(() => {
    fetchDoctors();
    if (params && params.patientId) {
      getPatient(params.patientId).then((res: any) => {
        const response = res.data.data;
        if (response?.historyData?.ongoingMedicines) {
          convertTextToPlainText(
            response?.historyData?.ongoingMedicines,
            setMedicines
          );
        }
        if (response?.historyData?.familyHistory) {
          convertTextToPlainText(
            response?.historyData?.familyHistory,
            setFamilyHistory
          );
        }
        // if (response?.historyData?.comments) {
        //   convertTextToPlainText(response?.historyData?.comments, setComments);
        // }
        if (response?.comments) {
          convertTextToPlainText(response.comments, setComments);
        }
        dispatch(changePatient(res.data.data));
      });
    }
  }, [dispatch, params]);

  const convertTextToPlainText = (
    text: any,
    setState: React.Dispatch<React.SetStateAction<string>>
  ) => {
    if (text) {
      const contentState = convertFromRaw(JSON.parse(text));
      const plainText = contentState.getPlainText();
      setState(plainText);
    }
  };
  const referredDoctorName =
    doctors.find((doc) => doc.id === patient.referredBy)?.name || "-";

  return (
    <div className="p-4 bg-white">
      <div>
        <h3 className="text-base font-semibold leading-7 text-gray-900">
          Summary
        </h3>
        <p className="max-w-2xl mt-1 text-sm leading-6 text-gray-700">
          Patient's personal details and medical history
        </p>
      </div>
      <div className="mt-6">
        <dl className="grid grid-cols-1 sm:grid-cols-4">
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Full name
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2 capitalize">
              {patient.firstName + " " + patient.lastName}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Phone
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2">
              {patient.phone}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Email address
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2">
              {patient.email}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Gender
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2 capitalize">
              {patient.gender}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Blood Group
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2 capitalize">
              {patient.bloodGroup}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Date of Birth
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2 capitalize">
              {patient.birthDate}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Aadhar Number
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2 capitalize">
              {patient.aadharNumber}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">Age</dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2 capitalize">
              {patient.age}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Address
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2 capitalize">
              {patient.address}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Referred By Doctor
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2 capitalize">
              {doctors.find((doc) => doc.id === patient.referredBy)?.name ||
                "-"}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-2 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Additional Details
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2">
              {comments}
            </dd>
          </div>

          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-1 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Allergies
            </dt>
            <dd className="flex gap-2 mt-1 text-sm leading-6 text-gray-500 sm:mt-2">
              {(patient.historyData.allergies || []).map(
                (allergy: { label: string; value: string }) => (
                  <span
                    key={allergy.value}
                    className="bg-yellow-100 px-2.5 py-0.5 text-sm font-medium text-yellow-800 rounded-full"
                  >
                    {allergy.label}
                  </span>
                )
              )}
            </dd>
          </div>

          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-2 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Previous Surgeries
            </dt>
            <dd className="flex gap-2 mt-1 text-sm leading-6 text-gray-500 sm:mt-2">
              {(patient.historyData.previousSurgeries || []).map(
                (surgery: { label: string; value: string }) => (
                  <span
                    key={surgery.value}
                    className="bg-yellow-100 px-2.5 py-0.5 text-sm font-medium text-yellow-800 rounded-full"
                  >
                    {surgery.label}
                  </span>
                )
              )}
            </dd>
          </div>

          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-2 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Previous Disease
            </dt>
            <dd className="flex gap-2 mt-1 text-sm leading-6 text-gray-500 sm:mt-2">
              {(patient.historyData.previousDiseases || []).map(
                (diseases: { label: string; value: string }) => (
                  <span
                    key={diseases.value}
                    className="bg-yellow-100 px-2.5 py-0.5 text-sm font-medium text-yellow-800 rounded-full"
                  >
                    {diseases.label}
                  </span>
                )
              )}
            </dd>
          </div>

          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-2 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Ongoing Medicines
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2">
              {medicines}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-2 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Family History
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2">
              {familyHistory}
            </dd>
          </div>
          <div className="px-4 py-6 border-t border-gray-200 sm:col-span-4 sm:px-0">
            <dt className="text-sm font-medium leading-6 text-gray-900">
              Habits
            </dt>
            <dd className="mt-1 text-sm leading-6 text-gray-500 sm:mt-2">
              {[
                patient.isAlcoholic ? "Alcoholic" : null,
                patient.isSmoking ? "Smoking" : null,
                patient.isBloodPressure ? "Blood Pressure" : null,
                patient.isDiabetic ? "Diabetic" : null,
                patient.isBloodDisorder ? "Blood Disorder" : null,
              ]
                .filter(Boolean)
                .join(", ") || "-"}
            </dd>
          </div>
        </dl>
      </div>
    </div>
  );
};

export default Summary;
